import React from 'react';

const When = ({ children, predicate }) => {
    return (!predicate) ? <></> : <>{children}</>;
};

export { When };